(function () {
  const OVERLAY_ID = 'searchOverlay';
  const STORAGE_RECENTS = 'search.recents.v1';
  const STORAGE_BAG = 'search.bag.v1';

  const qSel = (s, el = document) => el.querySelector(s);

  // Open/close helpers
  function openSearch() {
    const ov = qSel('#' + OVERLAY_ID);
    if (!ov) return;
    ov.hidden = false;
    ov.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => qSel('#predictiveSearchInput')?.focus(), 0);
    renderRecents();
    syncBagVisibility();
  }
  function closeSearch() {
    const ov = qSel('#' + OVERLAY_ID);
    if (!ov) return;
    ov.hidden = true;
    ov.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  // Wire triggers (you can add multiple open buttons)
  function bindGlobalTriggers() {
    document.addEventListener('click', (e) => {
      const openBtn = e.target.closest('[data-search-open]');
      const closeBtn = e.target.closest('[data-search-close]');
      const clearBtn = e.target.closest('[data-search-clear]');

      if (openBtn) {
        e.preventDefault();
        openSearch();
      }
      if (closeBtn) {
        e.preventDefault();
        closeSearch();
      }
      if (clearBtn) {
        const input = qSel('#predictiveSearchInput');
        if (input) {
          input.value = '';
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.focus();
        }
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeSearch();
      }
      // Quick open via "/" on desktop
      if (e.key === '/' && !e.metaKey && !e.ctrlKey && !e.altKey) {
        const target = e.target;
        const tag = (target?.tagName || '').toLowerCase();
        if (
          tag !== 'input' &&
          tag !== 'textarea' &&
          !target?.isContentEditable
        ) {
          e.preventDefault();
          openSearch();
        }
      }
    });
  }

  // Predictive search
  const input = qSel('#predictiveSearchInput');
  const resultsEl = qSel('#predictiveResults');
  const viewAllLink = qSel('[data-view-all]');
  const recentBox = qSel('[data-recent-searches]');

  function setViewAllHref(term) {
    if (viewAllLink) {
      const url = new URL(window.location.origin + '/search');
      url.searchParams.set('q', term || '');
      viewAllLink.href = url.pathname + url.search;
    }
  }

  function tplProduct(item) {
    const price = item.price
      ? (item.price / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: Shopify.currency.active || 'USD',
        })
      : '';
    const compare =
      item.compare_at_price && item.compare_at_price > item.price
        ? (item.compare_at_price / 100).toLocaleString(undefined, {
            style: 'currency',
            currency: Shopify.currency.active || 'USD',
          })
        : '';
    return `
    
      <li class="result-item" role="option" data-handle="${
        item.handle
      }" data-variant-id="${item?.variants?.[0]?.id || ''}">
      <a href="${item.url}">
        <img src="${item.image || item.featured_image?.url || ''}" alt="${
      item.title
    }">
        <div class="result-item__meta">
          <a class="result-item__title" href="${item.url}">${item.title}</a>
          <div class="result-item__price">
            ${price ? `<span class="price">${price}</span>` : ''}
            ${compare ? ` <s class="compare">${compare}</s>` : ''}
          </div>
        </div>
        </a>
      </li>
      
    `;
  }

  function renderResults(json, term) {
    const prods = json?.resources?.results?.products || [];
    const coll = json?.resources?.results?.collections || [];
    const pages = json?.resources?.results?.pages || [];
    const arts = json?.resources?.results?.articles || [];

    const prodsHtml = prods.length
      ? `
      <ul class="grid">${prods.map(tplProduct).join('')}</ul>
    `
      : '';

    const quickLinks = [...coll, ...pages, ...arts]
      .slice(0, 5)
      .map(
        (item) => `
      <a class="quick-link" href="${item.url}">${item.title}</a>
    `
      )
      .join('');

    resultsEl.innerHTML = `
      ${prodsHtml || `<p>No products found for “${escapeHtml(term)}”.</p>`}
    `;
    resultsEl.closest('.search-results').scrollTop = 0;
    resultsEl.setAttribute('aria-expanded', 'true');
  }

  function escapeHtml(s) {
    return (s || '').replace(
      /[&<>"']/g,
      (m) =>
        ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;',
        }[m])
    );
  }

  let t;
  async function onInput() {
    const term = (input?.value || '').trim();
    setViewAllHref(term);
    saveRecent(term);

    if (!term) {
      resultsEl.innerHTML = `<div class="search-placeholder"><p>Try “hoodie”, “linen”, or “gift card”.</p></div>`;
      renderRecents();
      return;
    }

    clearTimeout(t);
    t = setTimeout(async () => {
      try {
        // Predictive Search JSON
        const url = `/search/suggest.json?q=${encodeURIComponent(
          term
        )}&resources[type]=product,collection,page,article&resources[limit]=5&section_id=predictive-search`;
        const res = await fetch(url, {
          headers: { Accept: 'application/json' },
        });
        const json = await res.json();
        renderResults(json, term);
      } catch (e) {
        resultsEl.innerHTML = `<p>Something went wrong. Please try again.</p>`;
      }
    }, 140);
  }

  // Recent searches (localStorage)
  function saveRecent(term) {
    if (!term) return;
    const s = JSON.parse(localStorage.getItem(STORAGE_RECENTS) || '[]');
    const cleaned = [
      term,
      ...s.filter((x) => x.toLowerCase() !== term.toLowerCase()),
    ].slice(0, 5);
    localStorage.setItem(STORAGE_RECENTS, JSON.stringify(cleaned));
  }
  function renderRecents() {
    if (!recentBox) return;
    const s = JSON.parse(localStorage.getItem(STORAGE_RECENTS) || '[]');
    if (!s.length) {
      recentBox.hidden = true;
      return;
    }
    recentBox.hidden = false;
    recentBox.innerHTML = `
      <p>Recent searches:</p>
      <div class="chips">
        ${s
          .map(
            (term) =>
              `<button class="chip" type="button" data-recent-term="${escapeHtml(
                term
              )}">${escapeHtml(term)}</button>`
          )
          .join('')}
      </div>
    `;
  }

  // “Search Bag” (shortlist for quick compare)
  const bagEl = qSel('[data-search-bag]');
  const bagListEl = qSel('[data-bag-list]');
  const bagToggle = qSel('[data-bag-toggle]');

  function loadBag() {
    return JSON.parse(localStorage.getItem(STORAGE_BAG) || '[]');
  }
  function saveBag(arr) {
    localStorage.setItem(STORAGE_BAG, JSON.stringify(arr));
  }
  function renderBag() {
    if (!bagListEl) return;
    const items = loadBag();
    bagListEl.innerHTML = items.length
      ? items
          .map(
            (i) => `
      <li class="search-bag__item" data-handle="${i.handle}">
        <img src="${i.image || ''}" alt="">
        <div class="meta">
          <a href="${i.url}">${i.title}</a>
          ${i.price ? `<div class="price">${i.price}</div>` : ''}
        </div>
        <button type="button" data-bag-remove>Remove</button>
      </li>
    `
          )
          .join('')
      : `<li class="muted">No items yet. Add from results.</li>`;
  }
  function syncBagVisibility() {
    if (!bagEl || !bagToggle) return;
    const show = !!JSON.parse(
      localStorage.getItem('search.bag.show') || 'false'
    );
    bagToggle.checked = show;
    bagEl.hidden = !show;
    if (show) renderBag();
  }

  // Delegated clicks
  document.addEventListener('click', (e) => {
    // choose a recent term
    const chip = e.target.closest('[data-recent-term]');
    if (chip && input) {
      input.value = chip.getAttribute('data-recent-term');
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
    }

    // add to bag
    if (e.target.closest('[data-bag-add]')) {
      const li = e.target.closest('.result-item');
      if (!li) return;
      const handle = li.getAttribute('data-handle');
      const variantId = li.getAttribute('data-variant-id') || '';
      const title =
        li.querySelector('.result-item__title')?.textContent?.trim() || handle;
      const url =
        li.querySelector('.result-item__title')?.getAttribute('href') ||
        `/products/${handle}`;
      const img = li.querySelector('img')?.getAttribute('src') || '';
      const price = li.querySelector('.price')?.textContent || '';

      const bag = loadBag();
      if (!bag.find((i) => i.handle === handle)) {
        bag.push({ handle, variantId, title, url, image: img, price });
        saveBag(bag);
        renderBag();
        localStorage.setItem('search.bag.show', 'true'); // auto-open after first add
        syncBagVisibility();
      }
    }

    // remove from bag
    if (e.target.closest('[data-bag-remove]')) {
      const item = e.target.closest('.search-bag__item');
      const handle = item?.getAttribute('data-handle');
      if (!handle) return;
      const bag = loadBag().filter((i) => i.handle !== handle);
      saveBag(bag);
      renderBag();
    }

    // clear bag
    if (e.target.closest('[data-bag-clear]')) {
      saveBag([]);
      renderBag();
    }
  });

  // Toggle bag
  bagToggle?.addEventListener('change', () => {
    localStorage.setItem(
      'search.bag.show',
      bagToggle.checked ? 'true' : 'false'
    );
    syncBagVisibility();
  });

  // Input wireup
  input?.addEventListener('input', onInput);
  input?.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      const term = (input.value || '').trim();
      if (term) {
        window.location.href = `/search?q=${encodeURIComponent(term)}`;
      }
    }
  });

  // Openers in header builder
  bindGlobalTriggers();

  // Expose global helpers in case you want to trigger programmatically
  window.themeSearch = { open: openSearch, close: closeSearch };
})();
